export enum WizardStep {
  StoreCustomer = 0,
  Products = 1,
  DeliveryReview = 2,
}

export const WIZARD_STEPS = [
  {
    key: WizardStep.StoreCustomer,
    labelId: 'orderWizard.step.storeCustomer',
    defaultLabel: 'Store & Customer',
    optional: false,
  },
  {
    key: WizardStep.Products,
    labelId: 'orderWizard.step.products',
    defaultLabel: 'Products',
    optional: true,
  },
  {
    key: WizardStep.DeliveryReview,
    labelId: 'orderWizard.step.deliveryReview',
    defaultLabel: 'Delivery & Review',
    optional: false,
  },
] as const;

/** Earliest step that renders each form field — used to jump to the right
 * step when the API returns field-level submit errors. */
export const FIELD_STEP_MAP: Record<string, WizardStep> = {
  entity: WizardStep.StoreCustomer,
  currency: WizardStep.StoreCustomer,
  phoneNumber: WizardStep.StoreCustomer,
  secondPhoneNumber: WizardStep.StoreCustomer,
  externalReference: WizardStep.StoreCustomer,
  name: WizardStep.StoreCustomer,
  city: WizardStep.StoreCustomer,
  address: WizardStep.StoreCustomer,
  notes: WizardStep.StoreCustomer,
  products: WizardStep.Products,
  total: WizardStep.Products,
  deliveryRegion: WizardStep.DeliveryReview,
  deliveryCharge: WizardStep.DeliveryReview,
  amountIncludeDeliveryCharge: WizardStep.DeliveryReview,
};

export const stepForField = (field: string): WizardStep | undefined =>
  FIELD_STEP_MAP[field];

/** Fields the API usually rejects when empty — surfaced as non-blocking
 * hints in the review step. Not validation: submission is never blocked. */
export const REQUIRED_FIELD_HINTS = [
  {
    field: 'entity',
    labelId: 'forms.fields.entity',
    defaultLabel: 'Entity',
    step: WizardStep.StoreCustomer,
  },
  {
    field: 'name',
    labelId: 'forms.fields.customer',
    defaultLabel: 'Customer',
    step: WizardStep.StoreCustomer,
  },
  {
    field: 'phoneNumber',
    labelId: 'forms.fields.phoneNumber',
    defaultLabel: 'Phone Number',
    step: WizardStep.StoreCustomer,
  },
  {
    field: 'city',
    labelId: 'forms.fields.city',
    defaultLabel: 'City',
    step: WizardStep.StoreCustomer,
  },
  {
    field: 'address',
    labelId: 'forms.fields.address',
    defaultLabel: 'Address',
    step: WizardStep.StoreCustomer,
  },
  {
    field: 'deliveryRegion',
    labelId: 'delivery.deliveryCharge',
    defaultLabel: 'Delivery charge',
    step: WizardStep.DeliveryReview,
  },
] as const;
